var _defs, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIzolatieFonicaWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bddb3c67-39da-4254-b4d0-868691195fd6",
    "data-name": "izolatie_fonica",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ae0e1c44-42c4-4104-b471-acd4edb14db2,.f8c31965-fdb0-4c7a-b664-1ae89acfd5a7{fill:none;stroke:#fff;stroke-linejoin:round;}.f8c31965-fdb0-4c7a-b664-1ae89acfd5a7{stroke-linecap:round;stroke-width:10px;}.ae0e1c44-42c4-4104-b471-acd4edb14db2{stroke-width:8px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "izolatie_fonica_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f8c31965-fdb0-4c7a-b664-1ae89acfd5a7",
    x1: 5,
    y1: 60,
    x2: 5,
    y2: 140
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "f8c31965-fdb0-4c7a-b664-1ae89acfd5a7",
    x1: 25,
    y1: 40,
    x2: 25,
    y2: 160
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "f8c31965-fdb0-4c7a-b664-1ae89acfd5a7",
    x1: 45,
    y1: 50,
    x2: 45,
    y2: 150
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "f8c31965-fdb0-4c7a-b664-1ae89acfd5a7",
    x1: 65,
    y1: 30,
    x2: 65,
    y2: 170
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "f8c31965-fdb0-4c7a-b664-1ae89acfd5a7",
    x1: 85,
    y1: 10,
    x2: 85,
    y2: 190
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "ae0e1c44-42c4-4104-b471-acd4edb14db2",
    x1: 100,
    x2: 100,
    y2: 200
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "f8c31965-fdb0-4c7a-b664-1ae89acfd5a7",
    x1: 115,
    y1: 50,
    x2: 115,
    y2: 150
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "f8c31965-fdb0-4c7a-b664-1ae89acfd5a7",
    x1: 135,
    y1: 60,
    x2: 135,
    y2: 140
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "f8c31965-fdb0-4c7a-b664-1ae89acfd5a7",
    x1: 155,
    y1: 80,
    x2: 155,
    y2: 120
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "f8c31965-fdb0-4c7a-b664-1ae89acfd5a7",
    x1: 175,
    y1: 75,
    x2: 175,
    y2: 125
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "f8c31965-fdb0-4c7a-b664-1ae89acfd5a7",
    x1: 195,
    y1: 85,
    x2: 195,
    y2: 115
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIzolatieFonicaWhite);
export default __webpack_public_path__ + "static/media/izolatie_fonica_white.6f2a0cb58c92d4c110d62cb5a48959b8.svg";
export { ForwardRef as ReactComponent };